/** Tiny typed event bus for cross-module UI signals (not sim events). */
export class Emitter<M extends Record<string, unknown>> {
  private handlers: { [K in keyof M]?: Set<(p: M[K]) => void> } = {};
  on<K extends keyof M>(k: K, fn: (p: M[K]) => void): () => void {
    (this.handlers[k] ??= new Set()).add(fn);
    return () => this.handlers[k]?.delete(fn);
  }
  emit<K extends keyof M>(k: K, p: M[K]): void {
    this.handlers[k]?.forEach((fn) => fn(p));
  }
}
